import ArmorInfo from "./ArmorInfo";
export default ArmorInfo;
